import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import AudiencesService, {
  AudiencesIndexParams,
  AudiencesIndexResponse,
} from '../../services/audiences';

import { redirectToLogin } from '../../lib/auth';
import { useEffect } from 'react';
import { AxiosError } from 'axios';

export const AUDIENCES_QUERY_KEY = ['audiences'];

/**
 * Fetch audiences from mojo
 *
 * @param params - Optional query parameters for filtering/pagination
 * @param options - Optional React Query options
 * @returns Query result with audiences data
 */

export const useAudiencesQuery = (
  params?: AudiencesIndexParams,
  options?: Omit<
    UseQueryOptions<
      AudiencesIndexResponse,
      Error,
      AudiencesIndexResponse,
      string[]
    >,
    'queryKey' | 'queryFn'
  >
) => {
  const query = useQuery<
    AudiencesIndexResponse,
    Error,
    AudiencesIndexResponse,
    string[]
  >({
    queryKey: [...AUDIENCES_QUERY_KEY, JSON.stringify(params)],

    queryFn: async () => {
      const response = await new AudiencesService().fetchAll(params);
      return response.data;
    },

    meta: { persist: false },
    ...options,
  });

  return query;
};
